'use client';

import dynamic from 'next/dynamic';

const GlobalReach = dynamic(() => import('@/components/sections/global-reach').then((mod) => mod.GlobalReach), {
  ssr: false,
});

export function ClientGlobalReach() {
  return <GlobalReach />;
}
